import React, { useState, useEffect } from 'react'
import Sidebar from './Sidebar'
import ChatWidget from '../chat/ChatWidget'
import { ConversationProvider } from '../chat/ConversationContext'

const Layout = ({ children }) => {
  const [basicStats, setBasicStats] = useState(null)
  const [currentUser, setCurrentUser] = useState(null)
  const [documentId, setDocumentId] = useState(null)

  const fetchBasicStats = async () => {
    const basicStatsResponse = await fetch(`/collectors/api/basic_stats`, {
      headers: {
        Accept: 'application/json',
      },
    })
    const basicStatsJson = await basicStatsResponse.json()
    setBasicStats(basicStatsJson)
  }

  const fetchCurrentUser = async () => {
    try {
      const response = await fetch('/collectors/api/check_auth', {
        headers: {
          Accept: 'application/json',
        },
        credentials: 'same-origin', // Ensure cookies are sent
      })

      console.log('check_auth response status:', response.status)

      if (response.ok) {
        const data = await response.json()
        console.log('check_auth response data:', data)
        setCurrentUser(data.current_user)
      } else {
        console.error('check_auth failed with status:', response.status)
      }
    } catch (error) {
      console.error('Error fetching current user:', error)
    }
  }

  useEffect(() => {
    fetchBasicStats()
    fetchCurrentUser()

    // Extract document ID from URL if present
    const urlParams = new URLSearchParams(window.location.search)
    const docId = urlParams.get('filters[customer_document_id]')
    if (docId) {
      setDocumentId(docId)
    }
  }, [])

  // Debug logging
  console.log('Layout render - currentUser:', currentUser)
  console.log('Layout render - documentId:', documentId)

  return (
    <div className='container-fluid'>
      <div className='row flex-nowrap mb-12'>
        {basicStats == null ||
          (!basicStats.is_on_call_admin && (
            <div style={{ width: '220px' }} className='d-none d-md-block'>
              <Sidebar />
            </div>
          ))}

        <div style={{ flex: 1, minWidth: '320px' }}>
          {basicStats == null ||
            (!basicStats.is_on_call_admin && (
              <div className='d-md-none'>
                <Sidebar horizontal={true} />
              </div>
            ))}

          {children}
        </div>
      </div>

      {/* Add ChatWidget for authenticated users */}
      {currentUser && (
        <ConversationProvider currentUser={currentUser}>
          <ChatWidget currentUser={currentUser} documentId={documentId} />
        </ConversationProvider>
      )}
    </div>
  )
}

export default Layout
